// src/features/tasks/services/taskTemplates.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/task-management/templates';

export const taskTemplatesAPI = {
  getAllTemplates: () =>
    apiClient.get(`${BASE}/`),

  searchTemplates: (searchTerm) =>
    apiClient.get(`${BASE}/search`, { params: { search: searchTerm } }),

  getById: (templateId) =>
    apiClient.get(`${BASE}/${templateId}`),

  create: (data) =>
    apiClient.post(`${BASE}/`, data),

  update: (templateId, data) =>
    apiClient.put(`${BASE}/${templateId}`, data),

  delete: (templateId) =>
    apiClient.delete(`${BASE}/${templateId}`),
};
